/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsGet } from "../../funcs/accountsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiWorkspaceServiceV1AccountsIdRequest$inboundSchema,
};

export const tool$accountsGet: ToolDefinition<typeof args> = {
  name: "accounts_get",
  description: `Get account details`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
